/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledSimpleCard = styled.section`
  /* background-color: yellow; */
  border: 1px solid #e7e7e7;
  box-shadow: 0 0 8px 0 rgb(0 0 0 / 14%);
  border-radius: 5px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;

  &.simplecard-without-shadow {
    box-shadow: none !important;
  }
  &.simplecard-without-border {
    border: 0px !important;
    box-shadow: none !important;
  }
  &.simplecard--disabled {
    opacity: 0.5;
    pointer-events: none;
    user-select: none;
  }

  & p,
  & h1,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6,
  & h7 {
    color: #383638;
  }

  & .simplecard-head {
    padding: 16px;
    border-radius: 4px 4px 0 0;
    display: flex;
    justify-content: space-between;
    @media screen and (min-width: 768px) {
      padding: 24px 32px;
    }
    & p {
      font-size: 16px;
      line-height: 22px;
    }
    & h2 {
      font-size: 18px;
      line-height: 30px;
      @media screen and (min-width: 768px) {
        font-size: 24px;
      }
    }
    & h3 {
      font-size: 18px;
      line-height: 24px;
    }
    & .simplecard__title {
      color: #383838;
      font-size: 18px;
      line-height: 24px;
      font-weight: bold;
      @media screen and (min-width: 768px) {
        font-size: 24px;
        line-height: 30px;
      }
    }
    & p.simplecard_subtitle {
      color: #383838;
      font-size: 14px;
      line-height: 20px;
      @media screen and (min-width: 768px) {
        font-size: 16px;
        line-height: 22px;
      }
    }
  }
  & .card-internal-dropdown-head {
    & p {
      font-size: 16px;
      line-height: 20px;
    }
  }

  & .simplecard-collapsed-head {
    /* border-bottom: 0px; */
  }
  & .simplecard-body {
    flex: 1 0 auto;
    /* padding: 16px 24px; */
    border-top: 1px solid #e7e7e7;
  }
  & .simplecard-body--hidden {
    display: none;
  }
  & button:focus {
    outline: none;
  }
  & .simplecard-foot {
    border-top: 1px solid #e7e7e7;
    padding: 16px 18px;
    @media screen and (min-width: 768px) {
      padding: 16px 32px;
    }
  }
`;
